import { render } from "./SetContributionFraction.vue?vue&type=template&id=6c84975d&scoped=true"
import script from "./SetContributionFraction.vue?vue&type=script&lang=js"
export * from "./SetContributionFraction.vue?vue&type=script&lang=js"

import "./SetContributionFraction.vue?vue&type=style&index=0&id=6c84975d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javon\\mgs\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c84975d"]])

export default __exports__